import {t} from 'i18next';
import React from 'react';
import usePresentationImport from '../../hooks/usePresentationImport';
import Button from '../../incase-domain/components/button/Button';

function FileImport({label = false, fullWidth = false}: {label?: boolean; fullWidth?: boolean}): JSX.Element {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const onPresentationInput = usePresentationImport();

    return (
        <div onClick={() => inputRef.current?.click()} className="u-flex u-v-center u-pointer" style={{width: fullWidth ? '100%' : ''}}>
            <input
                ref={inputRef}
                type="file"
                onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                    const {files} = ev.target;
                    if (files) onPresentationInput(files);
                }}
                style={{display: 'none'}}
                accept=".json, .nbl"
            />
            <Button leading="solar:upload-minimalistic-linear" size="xl" variant="ghost" square />
            {label && <div>{t('header.import')}</div>}
        </div>
    );
}

export default FileImport;
